module.exports = __webpack_public_path__ + "img/pethouse33.12d0ab7c.jpg";